import { createNamespacer, createReducer } from "../utils/reducers";
import { serverAddress } from "../config/env";

const { port } = JSON.parse(localStorage.getItem("userDetails") || "{}");

const initialState = {
  serverUrl: serverAddress.hostname,
  serverPort: port || serverAddress.port,
  serverProtocol: serverAddress.protocol.replace(":", ""),
};

const namespacer = createNamespacer("SERVER_DETAILS");

const handlers = {
  [`${namespacer("SET_SERVER_ENDPOINT")}`]: (state: any, action: any) => ({
    ...state,
    serverUrl: action.payload.value,
  }),

  [`${namespacer("SET_SERVER_PORT")}`]: (state: any, action: any) => ({
    ...state,
    serverPort: action.payload.value,
  }),
};

const serverReducer = createReducer(initialState, handlers, ["SERVER_DETAILS"]);

export default serverReducer;